import { Status } from "./Status";


export class SpecimenStatusSmartEnum {
    static Packed = new Status("Packed", 1, "pill--green");
    static Disposed = new Status("Disposed", 2, "pill--red");
    static Disposing = new Status("Disposing", 3, "pill--orange");
    static Merged = new Status("Merged", 4, "pill--blue");
    static Recalling = new Status("Recalling", 5, "pill--blue");
    static Recalled = new Status("Recalled", 6, "pill--blue");
    static Created = new Status("Created", 7, "pill--grey");
    static Picked = new Status("Picked", 8, "pill--orange");
    static Invalid = new Status("Not Found", 9, "pill--red", "Invalid"); // Even though the state is technically invalid, cellnass want it displaying as not found
    static Returning = new Status("Returning", 10, "pill--orange");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "SpecimenStatusSmartEnum";
    }
}
